import { useEffect } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQS } from "../lib/data";
import { TID } from "../lib/testIds";

export default function FAQ() {
  // Inject FAQ JSON-LD schema for SEO
  useEffect(() => {
    const id = "af-faq-schema";
    const existing = document.getElementById(id);
    if (existing) existing.remove();
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

  return (
    <section className="bg-black py-20 lg:py-28">
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <p className="af-eyebrow text-center mb-3">FAQ</p>
        <h2 className="text-center text-4xl sm:text-5xl font-bold mb-12 text-[#DC2626]">
          FREQUENTLY ASKED QUESTIONS
        </h2>
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="border-b border-[#262626]"
              data-testid={TID.faqItem(i)}
            >
              <AccordionTrigger className="text-left text-white text-base lg:text-lg font-semibold hover:text-[#DC2626] hover:no-underline py-6 font-display">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-neutral-400 text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
